"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GLFilter = _interopRequireDefault(require("./GLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class GLCopyFilter extends _GLFilter.default {
  constructor() {
    const fsSource = `
        precision mediump float;
        varying highp vec2 v_uv;

        uniform sampler2D t_tex;
        uniform float scale;

        void main() {
            vec2 uv = v_uv * scale;
	        uv.y = 1.0 - uv.y;
            gl_FragColor = texture2D(t_tex, uv);
        }
        `;
    super(fsSource);
    this._scale = 1.0;
  }

  initUniformLocations(gl, program) {
    var uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.scale = gl.getUniformLocation(program, 'scale');
    return uniformLocations;
  }

  willDraw(gl, uniformLocations, attributeLocations, flip) {
    super.willDraw(gl, uniformLocations, attributeLocations, flip);
    gl.uniform1f(uniformLocations.scale, this._scale);
  }

  setScale(value) {
    this._scale = value;
  }

  getScale() {
    return this._scale;
  }

}

exports.default = GLCopyFilter;